import { render, staticRenderFns } from "./SorteoHistoricoTotales.vue?vue&type=template&id=2e037f7b&"
import script from "./SorteoHistoricoTotales.vue?vue&type=script&lang=ts&"
export * from "./SorteoHistoricoTotales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports